export function getCssVariables(...vars) {
  const styles = getComputedStyle(document.documentElement);
  const colorMap = {};

  vars.forEach((v) => {
    const value = styles.getPropertyValue(v);
    if (value) {
      colorMap[v.replace('--', '')] = value.trim();
    }
  });

  return colorMap;
}


